export const TRACK_THING_LIST_ROW_DEFAULT_TEMPLATE = {
  op: 'ui',
  name: 'ListRow',
  sx: {
    justifyContent: 'space-between',
    '.ListPaperColumn-root.property:nth-of-type(n + 4)': {
      display: 'none',
    },
    '> .ListPaperColumn-root:first-child:nth-last-child(3), .ListPaperColumn-root:first-child:nth-last-child(3) ~ .ListPaperColumn-root': {
      '&.ListPaperColumn-root.property': {
        width: '50%',
      },
    },
  },
  children: [
    {
      op: 'ui',
      name: 'DisplayColumn',
      data: {
        op: 'context',
        path: 'thing',
      },
    },
    {
      op: 'array:map',
      items: [
        { path: 'sharedProperties', index: 0 },
        { path: 'sharedProperties', index: 1 },
        { path: 'properties', index: 0 },
        { path: 'properties', index: 1 },
      ],
      to: {
        op: 'ui',
        name: 'ThingPropertyColumn',
        thing: {
          op: 'context',
          path: 'context.thing',
        },
        shared: {
          op: 'if',
          condition: {
            op: 'eq',
            a: {
              op: 'context',
              path: 'item.path',
            },
            b: 'sharedProperties',
          },
          then: true,
          else: false,
        },
        property: {
          op: 'context',
          path: [
            'context',
            'thingType',
            {
              op: 'context',
              path: 'item.path',
            },
            'order',
            {
              op: 'context',
              path: 'item.index',
            }],
        },
      },
    },
    {
      op: 'ui',
      name: 'GroupColumn',
      data: {
        op: 'context',
        path: 'thing',
      },
    },
  ],
};

export const ADMIN_THING_LIST_ROW_DEFAULT_TEMPLATE = {
  op: 'ui',
  name: 'ListRow',
  sx: {
    '.ListPaperColumn-root.property:nth-of-type(n + 5)': {
      display: 'none',
    },
  },
  children: [
    {
      op: 'ui',
      name: 'DisplayColumn',
      data: {
        op: 'context',
        path: 'thing',
      },
    },
    {
      op: 'array:map',
      items: [
        { path: 'sharedProperties', index: 0 },
        { path: 'sharedProperties', index: 1 },
        { path: 'sharedProperties', index: 2 },
        { path: 'properties', index: 0 },
        { path: 'properties', index: 1 },
        { path: 'properties', index: 2 },
      ],
      to: {
        op: 'ui',
        name: 'ThingPropertyColumn',
        thing: {
          op: 'context',
          path: 'context.thing',
        },
        shared: {
          op: 'if',
          condition: {
            op: 'eq',
            a: {
              op: 'context',
              path: 'item.path',
            },
            b: 'sharedProperties',
          },
          then: true,
          else: false,
        },
        property: {
          op: 'context',
          path: [
            'context',
            'thingType',
            {
              op: 'context',
              path: 'item.path',
            },
            'order',
            {
              op: 'context',
              path: 'item.index',
            }],
        },
      },
    },
  ],
};

export const THING_LIST_DEFAULT_TEMPLATE = {
  op: 'ui',
  name: 'DataGrid',
  paginationMode: 'server',
  sortingMode: 'server',
  sortingOrder: ['asc', 'desc'],
  disableSelectionOnClick: true,
  hideFooter: true,
  pageSize: 25,
  loading: {
    op: 'context',
    path: 'loading',
  },
  disableColumnMenu: true,
  sort: {
    op: 'context',
    path: 'sort',
  },
  onSortChange: {
    op: 'context',
    path: 'onSort',
  },
  columnVisibilityModel: {
    id: false,
  },
  columns: {
    op: 'map',
    array: [{
      field: 'id',
    },
    {
      field: 'display',
      translation: 'common:common.labels.display',
      sortable: true,
      minWidth: 300,
      flex: 1,
      template: {
        op: 'ui',
        name: 'HrefLink',
        to: {
          op: 'array-join',
          value: ['/thing/', {
            op: 'context',
            path: 'id',
          }],
          separator: '',
        },
        children: {
          op: 'ui',
          name: 'BoldMatchedText',
          text: {
            op: 'context',
            path: 'display',
          },
        },
      },
    }, {
      field: 'groupIds',
      sortable: false,
      translation: 'common:terms.group_other',
      flex: 2,
      minWidth: 200,
      template: {
        op: 'ui',
        name: 'GroupColumn',
        hideLabel: true,
        data: {
          op: 'context',
        },
      },
    }, {
      field: 'tags',
      sortable: false,
      translation: 'common:terms.tag',
      flex: 2,
      minWidth: 200,
      template: {
        op: 'ui',
        name: 'Tags',
        tags: {
          op: 'context',
          path: 'tags',
        },
      },
    }],
    as: 'headers',
    body: {
      field: {
        op: 'context',
        path: 'headers.field',
      },
      flex: {
        op: 'context',
        path: 'headers.flex',
      },
      sortable: {
        op: 'context',
        path: 'headers.sortable',
      },
      headerName: {
        op: 'if',
        condition: {
          op: 'context',
          path: 'headers.translation',
        },
        then: {
          op: 'translate',
          translation: {
            op: 'context',
            path: 'headers.translation',
          },
        },
        else: {
          op: 'context',
          path: 'headers.headerName',
        },
      },
      minWidth: {
        op: 'context',
        path: 'headers.minWidth',
      },
      template: {
        op: 'context',
        path: 'headers.template',
      },
    },
  },
  rows: {
    op: 'map',
    array: {
      op: 'context',
      path: 'items',
    },
    as: 'thing',
    body: {
      id: {
        op: 'context',
        path: 'thing._id',
      },
      display: {
        op: 'context',
        path: 'thing.display',
      },
      groupIds: {
        op: 'context',
        path: 'thing.groupIds',
      },
      tags: {
        op: 'context',
        path: 'thing.tags',
      },
    },
  },
};
